interface AgeFilterOptionsProps {
  onChange: (args?: any) => any;
  value: string;
}

const AgeFilterOptions: React.FC<AgeFilterOptionsProps> = ({
  onChange,
  value,
}) => {
  return (
    <div className="p-4">
      <input
        onChange={onChange}
        type="numeric"
        inputMode="numeric"
        placeholder="Enter age"
        value={value}
        className="w-full p-2 border-2 outline-none border-primary-2 rounded-input focus:border-primary font-base"
      />
    </div>
  );
};

export default AgeFilterOptions;
